import Profile from './Profile'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/profile',
      component: Profile,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/profile/profileConfig.js